import { IconName } from '@optimus-web/icons';
import { lt } from '@mews/framework';
import { DropdownItem, Icon } from '@optimus-web/core';

interface DraftAReplyProps {
    handleDraftAReply: () => void;
}

export const DraftAReply = ({ handleDraftAReply }: DraftAReplyProps) => (
    <DropdownItem
        label={lt('CommunicationHubDraftAReply')}
        value="1"
        leftDetail={<Icon value={IconName.AI} />}
        onClick={handleDraftAReply}
    />
);
